import { render } from "./Backstage.vue?vue&type=template&id=f7792468&scoped=true"
import script from "./Backstage.vue?vue&type=script&lang=js"
export * from "./Backstage.vue?vue&type=script&lang=js"

import "./Backstage.vue?vue&type=style&index=0&id=f7792468&scoped=true&lang=css"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7792468"]])

export default __exports__